import React from 'react';

const Refund = () => {
    return (
        <div className="container">
            <br />
            <h3 className="text-center">REFUND &amp; CANCELLATION POLICY</h3>
            <br />
            <p className="mb8"><strong>Refund and Cancellation Policy</strong></p>
            <p className="mb8">
                Our focus is complete customer satisfaction. In the event you are displeased with the services provided, we will refund the money, provided the reasons are genuine and proven after investigation. Please read the fine print of each deal before buying—it provides all the details about the services or products you purchase.
            </p>
            <p className="mb14">
                In case of dissatisfaction with our services, clients have the liberty to cancel their order and request a refund. Our policy for cancellation and refund is as follows:
            </p>
            <p className="mb8">
                <strong>1. Cancellation Policy:</strong> For cancellation, please contact us via the ‘Contact Us’ link. <strong>Cancellation can be done within 1 day of placing the order.</strong> Requests for cancellation received after the shipment is dispatched shall be at the sole discretion of Mattress Compay Name.
            </p>
            <p className="mb8">
                <strong>2. Refund Policy:</strong> If the product delivered is different from the one ordered or if the client is not satisfied, we may provide a refund. <strong>If approved, the refund will be credited to the original payment method within 10 business days.</strong> Refunds will not be entertained without a genuine reason or if not reported within 3 hours of delivery.
            </p>
            <p className="mb8">
                <strong>3. Return Policy:</strong> We have a 10-day return policy. <strong>You can return the product in its original condition and with tags within 10 days.</strong>
            </p>
            <p className="mb8">
                If paid by credit card, refunds will be issued to the original credit card used at the time of purchase. For other payment gateways, refunds will be made to the same account.
            </p>
            <p className="mb8">
                The mode of refund and its conditions are at the sole discretion of Mattress Compay Name.
            </p>
            <p className="mb8">
                If the payment mode was Cash on Delivery, we will refund the amount to a bank account of your choice. Bank details will be taken during the refund process. Please ensure the details provided are correct. Mattress Compay Name is not responsible for funds transferred to an unintended recipient due to incorrect details.
            </p>
            <p className="mb8">
                In case the product was not delivered but you received a delivery confirmation via email/SMS, report the issue within 3 days of the delivery confirmation to allow the seller to investigate.
            </p>
            <p className="mb8">
                The timeline to process the refund is 10 working days from the date of cancellation.
            </p>
        </div>
    );
};

export default Refund;
